import { MutationTree } from "vuex";
import getDefaultState from "./state";
import { GuardChatStore } from "./types";

export const mutations: MutationTree<GuardChatStore> = {
	addMessages(state, { eventId, messages }) {
		if (!state.guardChatList[eventId]) {
			state.guardChatList[eventId] = { messages: [], numberOfUnread: 0 };
		}
		state.guardChatList[eventId]?.messages.push(...messages);
	},
	setNumberOfUnread(state, { eventId, numberOfUnread }) {
		if (!state.guardChatList[eventId]) {
			state.guardChatList[eventId] = { messages: [], numberOfUnread: 0 };
		}
		state.guardChatList[eventId].numberOfUnread = numberOfUnread;
	},
	resetState(state){
		Object.assign(state, getDefaultState());
	},
	setMessagesEventId(state, eventId) {
		state.activeMessagesEventId = eventId;
	}
};
